import {BettingZoneAssetsRequestParams} from "../../../../../../../infrastructure/models/params/betting-zone.assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../../../../core/app/consts";

export class BrandReviewOffersO18ImageRequestParams extends BettingZoneAssetsRequestParams {
  constructor(width, height) {
    super({width, height});

    this.resourceName = this.resourceName + `/18-plus-1`;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}